import {FACULDADEPLAYAPI } from "./Api";

export default {

  /**
   *  Retorna os requerimentos de determinado aluno
   * @param {*} data
   */
  async buscarRequerimentosAluno(data) {
    return await FACULDADEPLAYAPI.post("buscar-requerimentos-por-curso/", JSON.stringify(data));
  },


  /**
   *  Retorna a lista de cursos do aluno
   * @param {*} data
   */
   async buscarCursosAluno(data) {
     return await FACULDADEPLAYAPI.post("buscar-cursos-aluno/", JSON.stringify(data));
  },

  /**
   *  Retorna a lista de cursos do aluno
   * @param {*} data
   */
  async secretariaBuscarCursosAluno(data) {
      return await FACULDADEPLAYAPI.post("secretaria-buscar-cursos-aluno/", JSON.stringify(data));
  },


  /**
   *  Editar um retorno de requerimento
   * @param {*} data
  */
  async editarRequerimento(data) {
    return await FACULDADEPLAYAPI.post("secretaria-editar-requerimento/", JSON.stringify(data));
  },
  

  /**
   *  valida login de usuário da secretaria
   * @param {*} data
   */
  async validarUsuarioSecretaria(data) {
     return await FACULDADEPLAYAPI.post("/validar-usuario-secretaria/", JSON.stringify(data));
  },


  /**
   *  salva o retorno do requerimento
   * @param {*} data
   */
   async SalvarRetornoRequerimento(data) {
    return await FACULDADEPLAYAPI.post("/salvar-retorno-requerimento/", JSON.stringify(data));
   },


  /**
   *  valida o token de acesso do usuário
   * @param {*} data
   */
   async validarTokenAcesso(data) {
    return await FACULDADEPLAYAPI.post("/validar-token-acesso/", JSON.stringify(data));
   },


  /**
   *  valida o token de acesso do usuário
   * @param {*} data
   */
  async buscarAlunosRequerimentoPendente(data) {
    return await FACULDADEPLAYAPI.post("/buscar-alunos-requerimento-pendente/", JSON.stringify(data));
  },

  /**
   *  valida o token de acesso do usuário
   * @param {*} data
   */
  async abrirTicketContato(data) {
    const retorno = await FACULDADEPLAYAPI.post("/abrir-ticket/", JSON.stringify(data));
    //console.log('ticket:', retorno);
    
    // console.log(data);
    // const retorno = 
    //   {
    //     "status": "ok",
    //     "message": "ok",
    //     "code": 200,
    //     "data": {
    //       "ticket": 46543,
    //       "message": "O ticket 46543 foi criado com sucesso!",
    //       "flag": true
    //     }
    //   }
    return retorno.data; 
  },

  /**
   *  valida o token de acesso do usuário
   * @param {*} data
   */
  async visualizarContrato(data) {
    //console.log('URL completa:', FACULDADEPLAYAPI.defaults.baseURL + '/visualizar-contratos');
    //console.log('Dados enviados:', data);
        
    const retorno = await FACULDADEPLAYAPI.post("/visualizar-contratos/", JSON.stringify(data));

    //console.log('respondeu:', retorno);
    
    // console.log(data);
    // const retorno = 
    //   {
    //         "status": "ok",
    //         "httpStatusCode": 200,
    //         "data": {
    //             "contratos": [{
    //                     "CodUnidade": 118,
    //                     "CPF": "413.219.198-24",
    //                     "Curso": "PEDAGOGIA",
    //                     "Modulo": 1,
    //                     "LinkContrato": "https://painel.autentique.com.br/documentos/60bafa8195340b80ab9b251f2a9ba02c24266e9813469888e",
    //                     "NomeAluno": "MICHEL DOUGLAS DA SILVA GERALDINO"
    //                 }
    //             ]
    //         }
    //     }

    return retorno.data; 

  }  

};
